import React from 'react';

import { Button, LinkButton } from '@eika/button';
import { Link, LinkType } from '@eika/link';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useConfig } from '../../../../../defaultConfig';
import useTranslation from '../../../../../hooks/useTranslation';
import { paymentTrackIDs } from '../../../../../utils/gtm/trackIDs/payment';

import './StepUpRequired.scss';

export interface Props {
    onClose(): void;
    onUndo(): void;
}

export const StepUpRequired: React.FC<Props> = ({ onClose, onUndo }) => {
    const translated = useTranslation();

    const { stepUpAuthLink } = useConfig();
    return (
        <div className="stepUpRequired__wrapper">
            <RichIcon type={RichIconTypes.HAAND_HEIHEI} maxHeight={144} minHeight={144} />
            <h3 className="typography-h3 stepUpRequired__title">{translated.immediatePayment.stepUpRequired.title}</h3>
            <div className="stepUpRequired__text">
                <p className="typography-paragraph-mixin">{translated.immediatePayment.stepUpRequired.text1}</p>
                <p className="typography-paragraph-mixin">{translated.immediatePayment.stepUpRequired.text2}</p>
                <p className="typography-paragraph-mixin">{translated.immediatePayment.stepUpRequired.text3}</p>
            </div>
            <Link
                className="stepUpRequired__button"
                linkType={LinkType.BUTTON_STANDARD_POSITIVE}
                href={stepUpAuthLink?.url ?? '/'}
                data-track-id={paymentTrackIDs.stepUp}
                data-track-linkname={translated.immediatePayment.stepUpRequired.start}
            >
                {translated.immediatePayment.stepUpRequired.start}
            </Link>
            <Button
                buttonType="negative"
                size="standard"
                onClick={onUndo}
                data-track-id={paymentTrackIDs.stepUp}
                data-track-linkname={translated.immediatePayment.stepUpRequired.back}
            >
                {translated.immediatePayment.stepUpRequired.back}
            </Button>
            <LinkButton
                size="standard"
                onClick={onClose}
                data-track-id={paymentTrackIDs.stepUp}
                data-track-linkname={translated.immediatePayment.stepUpRequired.back}
            >
                {translated.cancel}
            </LinkButton>
        </div>
    );
};
